import { theme } from '@approvalmax/theme';
import { BigAlertIcon, ReportInProgressIcon } from 'modules/sprites';
import styled, { css } from 'styled-components';

const iconCommonStyles = css`
    fill: ${theme.color.midnight60};
`;

export const StyledReportInProgressIcon = styled(ReportInProgressIcon)`
    ${iconCommonStyles}
`;
export const StyledBigAlertIcon = styled(BigAlertIcon)`
    ${iconCommonStyles}
`;
